<template lang="html">
    <div class="profile">
        <div class="profile__image" v-if="skeleton">
            <div class="profile__image-gradient skeleton" ref="imageBackground"></div>
        </div>
        <div class="profile__image" v-else>
            <div class="profile__image-gradient" ref="imageBackground"></div>
            <img :src="specialist.image_url" ref="image" crossorigin="anonymous" />

            <div class="profile__video-button" v-if="specialist.video_url">
                <i class="far fa-play-circle" @click="$emit('toggleMediaModal')"></i>
            </div>
            <div class="profile__video-status" v-if="specialist.video_url">
                <i class="fas fa-photo-video"></i>
            </div>
            <div class="profile__video-status profile__video-status--mobile" v-if="specialist.video_url">
                <i class="fas fa-play-circle" @click="$emit('toggleMediaModal')"></i>
            </div>
        </div>
        <div class="profile__info" v-if="skeleton" style="flex: 1">
            <div class="profile__title skeleton" style="height: 20px; max-width: 150px; margin-bottom: 30px; margin-top: 10px;" />
            <div class="profile__name header-3 skeleton" style="height: 30px; max-width: 300px; margin-bottom: 50px;" />
            <div class="profile__description skeleton" style="height: 15px;" />
            <div class="profile__description skeleton" style="height: 15px;" />
            <div class="profile__description skeleton" style="height: 15px; max-width: 80%; max-width: 300px; margin-bottom: 80px;" />

            <div class="profile__description skeleton" style="border-radius: 9999px; height: 35px;" />
        </div>
        <div class="profile__info" v-else>
            <div class="profile__title" v-if="specialist.title">
                {{specialist.title}}
            </div>
            <div class="profile__name header-3" v-if="specialist.full_name">
                {{specialist.full_name}}
            </div>
            <StarRating class="profile__stars" :rating="parseInt(specialist.feedback_grade)" />
            <div class="profile__categories">
                <div class="profile__category" v-for="(category, i) in specialist.categories" :key="i">
                    {{category.name}}
                </div>
            </div>
            <div class="profile__description" v-html="specialist.about">
            </div>
            <div class="profile__readmore">
                <a @click="$store.state.specialist.modals.description = true">Află mai multe..</a>
            </div>
            <button class="profile__action" v-if="$store.state.user.user.role == 'client'"
                @click="$store.state.specialist.modals.buyService = true">

                Cumpară o ședinta
                <span>{{specialist.service_price}} <i class="fas fa-coins"></i></span>
            </button>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    import StarRating from '@/components/ui/StarRating'

    export default {
        components: {
            StarRating
        },
        props: {
            skeleton: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                specialist: "specialist/specialist"
            })
        },
        methods: {
            processBackground() {
                let processBackgroundEnabled = false; //Added by RJ - temporar, dezactivam processBg

                if(processBackgroundEnabled){
                    try {
                        if (this.$refs.image === undefined) {
                            return;
                        }

                        this.$refs.image.onload = () => {
                            const image = this.$refs.image;

                            let gradientData = []
                            let imageData = [];

                            let canvas = document.createElement('canvas');
                            let ctx = canvas.getContext('2d');

                            let imageDimensions = {
                                width: 0,
                                height: 0
                            };

                            imageDimensions.width = image.width * 0.1;
                            imageDimensions.height = image.height * 0.1;

                            canvas.width = imageDimensions.width;
                            canvas.height = imageDimensions.height;
                            ctx.drawImage(image, 0, 0, imageDimensions.width, imageDimensions.height);

                            imageData = ctx.getImageData(0, 0, imageDimensions.width, imageDimensions.height).data;
                            imageData = Array.from(imageData);

                            let chunked = imageData.reduce((ar, it, i) => {
                                const ix = Math.floor(i / 4)
                                if (!ar[ix]) {
                                    ar[ix] = []
                                }
                                ar[ix].push(it);
                                return ar
                            }, []);

                            chunked = chunked.filter(rgba => {
                                return rgba.slice(0, 2).every(val => val < 250) && rgba.slice(0, 2).every(val => val > 0)
                            });

                            chunked = chunked.reduce((accum, current) => {
                                let key = current.join('|');
                                if (!accum[key]) {
                                    accum[key] = 1;
                                    return accum
                                }
                                accum[key] = ++(accum[key]);
                                return accum
                            }, {});

                            const occurs = Object.keys(chunked).map(key => {
                                const rgbaKey = key;

                                let components = key.split('|');

                                let brightness = ((components[0] * 299) + (components[1] * 587) + (components[2] * 114)) / 1000
                                    return {
                                        rgba: rgbaKey.split('|'),
                                        occurs: chunked[key],
                                        brightness
                                    }
                                }
                            ).sort((a, b) => a.occurs - b.occurs).reverse().slice(0, 10);

                            let sorted = occurs.sort((a, b) => a.brightness - b.brightness).reverse()
                            let top = [sorted[0], sorted[sorted.length - 1]]

                            const val = top.map((color, index) => {
                                return `rgb(${color.rgba.slice(0, 3).join(',')}) ${index == 0 ? '0%' : '75%'}`
                            }).join(',');

                            const prefixes = ['webkit'];
                            let gradientProperty = prefixes.map(prefix => {
                                return `background-image: -${prefix}-linear-gradient(
                                            135deg,
                                            ${val}
                                        )`
                            }).concat([`background-image: linear-gradient(
                                        135deg,
                                        ${val}
                                    )`]).join(';')

                            let textProperty;
                            const start = top[0].rgba.slice(0,3);
                            const end = top[1].rgba.slice(0,3);

                            let w = 0.5 * 2 - 1;
                            let w1 = (w + 1) / 2.0;
                            let w2 = 1 - w1;
                            let rgb = [parseInt(start[0] * w1 + end[0] * w2), parseInt(start[1] * w1 + end[1] * w2), parseInt(start[2] * w1 + end[2] * w2)];

                            let o = Math.round(((parseInt(rgb[0]) * 299) + (parseInt(rgb[1]) * 587) + (parseInt(rgb[2]) * 114)) /1000);

                            if (o > 125) {
                                textProperty = 'color: #000';
                            } else { 
                                textProperty = 'color: #fff';
                            }

                            this.$refs.imageBackground.style = `${ gradientProperty }; ${ textProperty }`;
                        }
                    } catch(e) {
                        console.log(e);
                    }
                }
                else try {
                    this.$refs.imageBackground.style = `background: white;`;
                } catch (e) {}
            }
        },
        mounted() {
            this.processBackground();
            
            let query = Object.assign({}, this.$route.query);
            
            if(this.$route.query.action && this.$route.query.action == 'readMore')
                setTimeout(() => {
                    this.$store.state.specialist.modals.description = true;
                    
                    delete query.action;
                    this.$router.replace({ query });
                }, 1000);
                
            if(this.$route.query.action && this.$route.query.action == 'makeAppointment')
                setTimeout(() => {
                    
                    // Auto open booking modal
                    this.$store.state.specialist.booking.servicesNumber = this.specialist.min_services;
                    this.$store.state.specialist.booking.active = true;
                    this.$store.state.specialist.booking.specialistId = this.specialist.id;

                    // Added by Andrei Preda - for not overlapping booking with other specialist page modals
                    this.$store.state.specialist.modals.addFeedback = false;
                    this.$store.state.specialist.modals.buyService = false;
                    this.$store.state.specialist.modals.buyPackage = false;
                    this.$store.state.specialist.modals.moreFeedbacks = false;
                    this.$store.state.specialist.modals.description = false;
                    
                    delete query.action;
                    this.$router.replace({ query });
                }, 1000);
        }
    }
</script>

<style lang="scss" scoped>
    .profile {
        background-color: white;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        height: auto;
        margin-top: 17px;
        text-align: center;
        width: 100%;

        @include media-breakpoint-up(sm) {
            flex-direction: row;
            text-align: left;
        }

        &__image {
            position: relative;
            height: 324px;
            margin: auto;
            min-width: 200px;
            width: 100%;

            display: flex;
            justify-content: center;
            overflow: hidden;

            img {
                height: 100%;
                object-fit: contain;
                //width: 100%;
                //max-width: 100%;
                z-index: 10;
                position: relative;
            }

            @include media-breakpoint-up(sm) {
                // > 576px
                height: 325px;
                min-width: 245px;
                max-width: 245px;

                img {
                    object-fit: cover;
                }
            }
        }

        &__image-gradient {
            background: linear-gradient(135deg,
                    $color-primary,
                    $color-secondary);
            height: 100%;
            left: 0;
            mix-blend-mode: normal;
            position: absolute;
            top: 0;
            transition: opacity 0.3s;
            width: 100%;
            z-index: 5;
        }

        @include media-breakpoint-up(md) {
            &__image:hover &__video-status {
                opacity: 0;
            }


            &__image:hover &__video-button {
                opacity: 1;
            }
        }

        &__video-button {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            background-image: $gradient-nexyo-faded;
            opacity: 0;
            transition: opacity .2s;
            font-size: 32px;
            display: none;
            align-items: center;
            justify-content: center;
            color: $color-card;
            z-index: 15;

            @include media-breakpoint-up(md) {
                display: flex;
            }

            i {
                cursor: pointer;
                font-size: 50px;
            }
        }

        &__video-status {
            position: absolute;
            bottom: 10px;
            left: 10px;
            width: 30px;
            height: 30px;
            background-color: $color-card;
            border-radius: 100%;
            color: $color-primary;
            font-size: 14px;
            align-items: center;
            justify-content: center;
            border: 1px solid $color-primary;
            transition: opacity .2s;
            display: none;
            z-index: 15;

            @include media-breakpoint-up(md) {
                display: flex;
            }

            &--mobile {
                background-color: transparent;
                color: white;
                font-size: 70px;
                border: none;
                display: flex;
                left: 50%;
                width: 50px;
                height: 50px;
                bottom: 50%;
                transform: translate(-50%, 50%);
                cursor: pointer;
                opacity: 0.8;

                i {
                    font-weight: 400;
                }

                @include media-breakpoint-up(md) {
                    display: none;
                }
            }
        }

        &__info {
            box-sizing: border-box;
        
            @include media-breakpoint-up(sm) {
                margin-left: 30px;
                max-width: calc(100% - 275px); //image width + margin-left
            }
        }

        &__title {
            color: $color-main-text;
            font-size: 14px;
            font-weight: 500;
            line-height: 28px;
        }

        &__name {
            margin-top: 21px;
        }

        &__stars {
            margin-top: 19px;
        }

        &__categories {
            display: flex;
            align-items: center;
            margin-top: 15px;
            max-width: 100%;
            overflow-x: auto;
            justify-content: flex-start;
        }

        &__category {
            align-items: center;
            border: 2px solid #C3C6D1;
            border-radius: 17px;
            display: flex;
            font-size: 13.33px;
            height: 30px;
            justify-content: center;
            padding: 0px 10px;
            white-space: nowrap;

            &:not(:last-child) {
                margin-right: 15px;
            }
        }

        &__description {
            font-size: 14px;
            font-weight: 300;
            height: 69px;
            max-height: 115px;
            margin-top: 20px;
            line-height: 23px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &__readmore {
            margin-top: 15px;

            a {
                color: $color-primary;
                font-size: 14px;
                font-weight: 400px;
                line-height: 24px;
                text-decoration: none;
            }

            &:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        }

        &__action {
            background-color: #EFF3F8;
            border-radius: 17.5px;
            color: $color-primary;
            box-shadow: 0px 0px 20px #0000000F;
            border: none;
            cursor: pointer;
            font-family: 'DIN Pro', sans-serif;
            font-weight: 500;
            font-size: 14px;
            height: 35px;
            line-height: 21px;
            margin-top: 17px;
            outline: none;
            width: 100%;

            &:hover {
                border: 1px solid $color-primary;
            }

            span {
                margin: 0 6px;
                color: $color-warning;
            }
        }

        &__user-services {
            margin-top: 10px;
            font-size: 14px;
            line-height: 23px;
            font-weight: 400;
            color: $color-gray;
            opacity: .7;
        }
    }
</style>